const isCardOwner = (collaborators, me) => collaborators?.accounts.filter((item) => (item.permissionLevel === 'OWNER')).some((item) => item.account.accountId === me?.accountId);

export {
  isCardOwner,
};
